const statuses = {
    to_do: {
        label: 'Inventaire critique',
        color: 'red',
    },
    soon_to_do: {
        label: 'Inventaire à faire',
        color: 'orange',
    },
    done: {
        label: 'Inventaire fait',
        color: 'green',
    },
}

export default function inventoryStatus(last_inventory_days = 1000) {
    const soonInventoryDays = 7
    let status_code = 'done'

    if (last_inventory_days > 0) {
        status_code = 'to_do'
    } else if (
        last_inventory_days >= -soonInventoryDays &&
        last_inventory_days <= 0
    ) {
        status_code = 'soon_to_do'
    }

    const mapped_status = statuses[status_code] || statuses.done

    return {
        ...mapped_status,
        code: status_code,
    }
}
